import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import {
  APQueryOptions,
  SHORT_STALE_TIME,
  useAPQuery,
} from "../../providers/APQueryProvider";

export const getMyEmployerActiveLeaseChartData = <TDatum,>(
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["employerActiveLeaseChartData"],
    queryFn: (): Promise<TDatum[]> => {
      return fetchWithAuth<TDatum[]>("getMyEmployerActiveLeaseChartData");
    },
    enabled: isQueryEnabled(options),
    staleTime: SHORT_STALE_TIME,
  });
};
